import { Fragment, useEffect, useState } from 'react';
import { TableRow, TableBody, TableCell, Collapse } from '@mui/material';
import CreateRowTable from './CreateRowTable';
import React from 'react';

export default function CreateTableBody(param, arrColumn, selectionModel, setSelectionModel, arrRowCollap, setarrRowCollap) {
    const [open, setOpen] = useState(true);

    const CheckRows = (row, index) => {
        return arrRowCollap.includes(row.nParentID) ?
            <TableRow>
                {CreateRowTable(param, row, setOpen, open, index, arrColumn, selectionModel, setSelectionModel, arrRowCollap, setarrRowCollap)}
            </TableRow>
            : null
    }

    return <TableBody>
        {
            param.rows ? param.rows.arrRows.map((row, index) => (
                <Fragment key={param.sTableID + "_" + row.sID}>
                    {
                        row.isCollapseHead ?
                            CheckRows(row, index)
                            :
                            <TableRow>
                                {CreateRowTable(param, row, setOpen, open, index, arrColumn, selectionModel, setSelectionModel, arrRowCollap, setarrRowCollap)}
                            </TableRow>
                    }
                </Fragment>
            )) : null
        }
    </TableBody>
}